module.exports = __webpack_public_path__ + "img/alert-circle-grey.5833ce66.svg";